import Vue from "vue";
import { baseVueController } from "./baseVueController";
import * as es6promise from "es6-promise";
import { idb, ui } from "./util";
import { dialogUtil } from "./util/dialog";
import { constDialogMessage } from "./util/const";
import { editInfo } from "./entity/idb/editInfo";
import { common } from "./util/common";
import { orderInfo } from "./entity/idb/orderInfo";
import { MultiTab } from "./util/multitab";
import { Logger } from "./util/logger";
import { util } from ".";
import { SSO } from "./util/sso";

// gigya
declare var gigya: any;

//------------------------------------------------------------------------------
// クラス
//------------------------------------------------------------------------------
/**
 * プレビュー画面コントローラクラス
 * */
export class previewController extends baseVueController {

    //--------------------------------------------------------------------------
    // 定数
    //--------------------------------------------------------------------------
    private readonly ELEMENT_NAME: string = "#previewController";

    // セッションストレージ用 戻る判定
    private readonly SESSION_STORAGE_FROM_PREV: string = "POSCA_FROM_PREV";

    // idb関連
    private readonly EDIT_INFO_STORENAME: string = "editInfo";
    private readonly OREDER_INFO_STORENAME: string = "orderInfo";

    // WebAPIのエンドポイント定義
    private readonly WebAPI_GetEditImage: string = "Edit/GetEditThumb";

    // 画面URL
    private readonly ViewURL_Edit: string = "Edit";
    private readonly ViewURL_HagakiSelect: string = "HagakiSelect";
    private readonly ViewURL_AddOrder: string = "AddOrder";

    /**
     * ガイダンスの表示タイムアウト値(ms)
     * */
    private readonly GUIDANCE_SHOW_TIMEOUT: number = 30000;
    /**
     * sessionStorage格納用キー：F5リロード判定用
     */
    private readonly SESSION_STORAGE_KEY_RELOADED: string = "PREVIEW_RELOADED";
    /**
     * sessionStorage格納用キー：編集画面からの再遷移判定用
     */
    private readonly SESSION_STORAGE_KEY_FROMEDIT: string = "PREVIEW_FROMEDIT";

    // 戻るボタン文言
    private readonly PC_GO_EDIT = "絵柄面の編集に戻る";
    private readonly PC_GO_ADD_ORDER = "追加注文に戻る";
    private readonly SP_GO_EDIT = "戻る";
    private readonly SP_GO_ADD_ORDER = "戻る";

    //--------------------------------------------------------------------------
    // 変数
    //--------------------------------------------------------------------------

    // idb
    private _editInfo: editInfo;
    private _orderInfo: orderInfo;

    private _token: string;

    /**
     * ロゴ１ URL
     */
    private _logo1Url: string;
    /**
     * ロゴ２ URL
     */
    private _logo2Url: string;

    /**
     * F5リロードアクセス？(SP用)
     */
    private doReloadedAccess: boolean;

    /**
     * beforeunloadイベント時の sessionStorageへの書き込み要否フラグ(SP用)
     */
    private doUnloadEventFunc: boolean;

    /**
     * 印刷タイプ(1:印刷, 2: 銀塩, 0:印刷・銀塩 両方)
     */
    private readonly PRINT_TYPE_PRINT: string = "1";
    private readonly PRINT_TYPE_GINEN: string = "2";
    private readonly PRINT_TYPE_BOTH: string = "0";


    //--------------------------------------------------------------------------
    // プロパティ
    //--------------------------------------------------------------------------


    //--------------------------------------------------------------------------
    // コンストラクタ
    //--------------------------------------------------------------------------
    constructor() {
        super();

        this.doReloadedAccess = false;
        this.doUnloadEventFunc = true;
    }


    //--------------------------------------------------------------------------
    // メソッド
    //--------------------------------------------------------------------------
    /**
     * 初期化メソッド
     * */
    public init(): void {

        // Androidの場合はmeta属性のmaximumを消す(拡大ができなくなるため)
        if (ui.isAndroid()) {
            const metaInfo = $('meta[name="viewport"]');
            $(metaInfo).attr('content', 'width=device-width, initial-scale=1.0');
        }

        // 複数タブ禁止
        const multiTabCheck = () => {
            MultiTab.forbiddenMultiTab(() => {
                dialogUtil.createErrorDialog(constDialogMessage.WARNING_MULTITAB_FORBIDDEN
                    , () => { }
                    , null
                    , true
                );
            })
        }
        setInterval(multiTabCheck, MultiTab.INTERVAL);

        // エラー時のボタン遷移先
        this.SetErrorPageInfo();

        // gigya イベントリスナー登録
        if (this._retailerConfig.id == "0") {
            gigya.socialize.addEventHandlers({
                onLogin: common.onLoginHandlerWithSave
                //onHide: common.onHideHandler
            });
		}

        // リテーラ毎の処理
        this.initRetailer();

        // vueオブジェクト生成
        this._vue = new Vue({
            el: this.ELEMENT_NAME,
            data: {
                editInfo: null,
                PrevButtonMessage: "",
                // ヘッダーメニュー
                Header: {
                    Logo1Url: this._logo1Url,
                    Logo2Url: this._logo2Url,
                },
                // 印刷か銀塩か
                isGinen: false,
                // 表示制御
                Show: {
                    // 操作方法の表示(空の場合は表示しない)
                    OperationInfo: this._retailerConfig.operationInfo.preview ? true : false,
                    // 1枚無料は保存ボタンを表示しない
                    SaveButton: false,
                    // ガイダンス
                    ImgGuidance: false,
                },

                // 仕上がり説明
                ReplaceImgGuideBaloon: {
                    top: "0",
                    left: "0",
                },
            },
            methods: {
                // 戻るボタン
                btnClickReturnFlow: (event: JQueryEventObject) => {
                    this.btnClickReturnFlow(event);
                },
                // 次へボタン
                btnClickNextFlow: (event: JQueryEventObject) => {
                    this.btnClickNextFlow(event);
                },
                // 一時保存
                btnClickSave: (event: JQueryEventObject) => {
                    this.btnClickSave(event);
                },
                // 操作方法
                btnClickOperationHelp: (event: JQueryEventObject) => {
                    this.btnClickOperationHelp(event);
                },
                // ガイダンス閉じる
                btnClickGuidanceClose: (event: JQueryEventObject) => {
                    this.btnClickGuidanceClose(event);
                },
                // ヘッダー
                btnClickReturnTop: (event: JQueryEventObject) => {
                    this.btnClickReturnTop(event);
                },
                btnClickFaq: (event: JQueryEventObject) => {
                    this.btnClickFaq(event);
                },
                btnClickOrderHistory: (event: JQueryEventObject) => {
                    this.btnClickOrderHistory(event);
                },
                // 説明文を消す
                onClickImgGuidance: (event: JQueryEventObject) => {
                    this.btnClickImgGuidance(event);
                }
            },
            mounted: () => {
                // リテーラ別のチャットボット制御
                var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
                if (divChatBot) {
                    divChatBot.style.display = this._retailerConfig.id == "0" ? "block" : "none";
                }

                this.doOnload();
            },
        });
        
    }

    /**
     * リテーラ別の初期化処理
     * */
    public initRetailer(): void {
        // リテーラロゴURL設定
        this._logo1Url = this._retailerConfig.logo1;
        this._logo2Url = this._retailerConfig.logo2;
    }

    /**
     * 画面初期化
     * */
    private async doOnload(): es6promise.Promise<void> {

        Logger.info("Preview start");

        // 複数タブの整合性破壊阻止
        if (MultiTab.isOldTab()) {
            Logger.log("複数タブ操作 古いタブの為初期化を中断しました。");
            return;
        }

        // ローディングダイアログ開始
        dialogUtil.showLoading();

        // tokenを画面から確保
        this.getAuthToken();

        // SSO
        Logger.log("SSO開始");
        await SSO.DoSSO(this._token, this._retailerConfig.id);

        if (!this._usePcDesign) {
            // SP用
            // F5リロード判定
            this.doReloadedAccess = this.doReloaded();
            // F5リロード監視
            this.unloadHandlerInit();
        }

        Logger.info("idb init start");

        // idb初期化＆接続
        //await idb.initiDB().catch(() => {
        //    // エラーメッセージを返す
        //    return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_CONNECT);
        //});
        // 上記をコメントアウトするとなぜか vueオブジェクトの生成が完了しないタイミングで
        // 「戻るボタンの文言」の処理が実行されるため、ダミー関数を呼ばせています。
        await this.dummyFucn();

        // 途中復帰か？
        if (this.getIsReturn()) {

            await SSO.WaitSSO();

            // idbの整合
            await common.InitReturn(this._token);

            // 戻るボタンの文言
            this._vue.$data.PrevButtonMessage = this.GetPrevButtonMessage(this._usePcDesign, false);

        } else {

            // 戻るボタンの文言
            this._vue.$data.PrevButtonMessage = this.GetPrevButtonMessage(this._usePcDesign, true);
		}

        // idbからのデータ読み込み
        this.loadIDB().then(async () => {

            if (!this._usePcDesign) {
                // SP用
                // ガイダンス表示制御
                this.showGuidance();
            }

            Logger.info("start initDisp");
            // 画面初期化
            this.initDisp().catch((msg) => {
                dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);
                return es6promise.Promise.reject;

            }).finally(() => {

                // ローディングダイアログ閉じる
                dialogUtil.closeLoading();

            });

            // 1枚無料は保存ボタンを表示させない。
            if (!this._orderInfo.isTrial) {
                this._vue.$data.Show.SaveButton = true;
			}

        }).catch((msg) => {
            dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);
            return es6promise.Promise.reject;
        });
	}

    private async dummyFucn(): es6promise.Promise<any> {
        return "";
    }

    /**
     * 戻るボタンの文言を取得します。
     * @param isPC
     * @param isGotoEdit
     */
    private GetPrevButtonMessage(isPC:boolean,isGotoEdit:boolean): string{

        if (isPC) {
            if (isGotoEdit) {
                return this.PC_GO_EDIT;
            } else {
                return this.PC_GO_ADD_ORDER;
			}
        } else {
            if (isGotoEdit) {
                return this.SP_GO_EDIT;
            } else {
                return this.SP_GO_ADD_ORDER;
            }
		}
    }

    /**
     * 
     * idbからデータを読み込んでローカルに保持します。
     * 
     * */
    private async loadIDB(): es6promise.Promise<any> {

        // editInfoからの取得
        this._editInfo = util.lstorage.get<editInfo>(util.lstorage.KEY_EDIT, true);
        if (!this._editInfo) {
            // エラーメッセージを返す
            return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_READ);
        }

        // orderInfoからの取得
        this._orderInfo = util.lstorage.get<orderInfo>(util.lstorage.KEY_ORDER, true);
        if (!this._orderInfo) {
            // nullであれば新規に作成する。
            this._orderInfo = new orderInfo();
            if (!util.lstorage.set(util.lstorage.KEY_ORDER, this._orderInfo)) {
                // エラーメッセージを返す
                return es6promise.Promise.reject<string>(constDialogMessage.ERROR_LOCAL_DB_READ);
            }
        }

	}

    /**
     * 編集状態サムネイル取得
     * imgの縦横サイズが欲しいのでjqueryで処理する。
     * */
    private async initDisp(): es6promise.Promise<any> {

        return new Promise((resolve, reject) => {

            const img = <HTMLImageElement>document.getElementById("previewImage");

             // imgタグに描画
            const param = "tempEditId=" + this._editInfo.tempId + "&token=" + this._token + "&timestamp=" + common.getTimeStamp();
            const that = this;

            // 画像取得
            util.ajax.postforblob_get(this.WebAPI_GetEditImage, param).then((data: Blob) => {

                // 画像描画
                var url = window.URL || window.webkitURL;
                img.src = url.createObjectURL(data);

                // サイズ変更
                const sizeFit = function () {

                    const content = document.getElementById("contents");

                    if (that.getIsPC()) {

                        // PC

                        // 縦横判定
                        let isH = true;
                        if (img.naturalHeight > img.naturalWidth) isH = false;

                        //// 拡縮率
                        //const scale = isH ? 0.70 : 0.98; //ヨコの場合は高さの70%

                        //// 描画サイズ
                        //let dstImgHeight = content.clientHeight * scale;
                        //const dstImgWidth = dstImgHeight * (img.naturalWidth / img.naturalHeight);

                        //// 高さ(横デザインの時に必要)
                        //let top = isH ? 100 : 0;

                        let top = isH ? '15%' : '';
                        let width = isH ? '40%' : '';
                        let height = isH ? '' : '95%';

                        // 画面の中央に表示する。
                        $("#previewImage").css({
                            top: top,
                            width: width,
                            height: height
                        });

                        const minWidth = isH ? $("#previewImage").height() : $("#previewImage").width();
                        const maxWidth = isH ? $("#previewImage").width() : $("#previewImage").height();
                        that.setImgBorderGuidanceBalloonPos($('#contents').width(), maxWidth, minWidth, !isH);
                    } else {

                        // SP
                        let aspect = img.naturalWidth / img.naturalHeight;
                        let actHeight = window.outerWidth / aspect;

                        // 上のガイドボタンの高さ
                        let guideH = $('#header').height();

                        // 下のガイドボタンの高さ
                        let guideF = $('#footer').height();

                        // 下の保存ボタンの高さ
                        let saveH = $('#save').height();
                        // プレビュー表示可能なエリア
                        let enableHeight = $(window).height() - (guideH + guideF + saveH);

                        if (actHeight > enableHeight) {

                            // 幅一杯にしたとき高さが一杯なので、高さで調整する。
                            let widthD = (enableHeight * img.naturalWidth / img.naturalHeight) - 15; // 微調整
                            let left = (outerWidth - widthD) / 2;
                            $("#previewImage").css({
                                position: "absolute",
                                left: left,
                                top: guideH + 2,
                                width: widthD,
                                border: '1px solid #333333',
                            });

                        } else {

                            let top = ($(window).height() / 2) - (actHeight / 2) - 30; // 画面中央だと少し余白が不自然なので固定であげておく。

                            // 幅一杯表示可能。
                            // 画面の中央に表示する。
                            $("#previewImage").css({
                                position: "absolute",
                                top: top,
                                width: 'calc(100% - 2px)',
                                border: '1px solid #333333',
                            });

                        }
                        that.setSpImgBorderGuidanceBalloonPos($("#previewImage").height(), $("#previewImage").width());
                    }

                    resolve("");
                }
                img.onload = sizeFit;

                // 失敗時
                img.onerror = function () {
                    $('#nextFlow').addClass('is-disabled');
                    reject(constDialogMessage.ERROR_GET_PREVIEW_TEXT);
                }

                // リサイズ
                $(window).resize(function () {
                    // PCのみリサイズ(SPは不要)
                    if (ui.usePcDesign()) {
                        sizeFit();
                    } 
                });

                // 銀塩用の注意書きを表示するか？
                if (this._editInfo.printType == this.PRINT_TYPE_GINEN) {
                    // isGinen
                    this._vue.$data.isGinen = true;
                    this._vue.$data.Show.ImgGuidance = true;
                }

                // 画像を読み込んでから実施すること。
                // 戻るボタンで編集画面にいってもInitTempを呼ばないようにフラグをたてておく
                Logger.info("set fromPrevInfo");
                this.setFromPrev();


            });

            

        })
        
    }

    /**
     * 認証トークン取得
     */
    private getAuthToken(): void {

        // hiddenから認証トークン取得＆クリア
        this._token = $("#Token").val();
        $("Token").val("");

    }

    /**
     * ガイダンスの表示制御(SP用)
     */
    private showGuidance(): void {

        // 再編集であるか判定
        if (this.getIsEdit()) {
            return;
        }

        // 追加注文であるか判定
        if (this.getIsReturn()) {
            return;
        }

        // F5リロードアクセスであるか判定
        if (this.doReloadedAccess) {
            return;
        }

        // ハガキ選択画面からの遷移であるかの判定
        if (this.checkFromReferrer("hagakiselect")) {
            return;
        }

        // 編集画面からの再遷移であるかの判定
        if (this.checkFromReferrer("edit")) {
            const fromEdit: string = sessionStorage.getItem(this.SESSION_STORAGE_KEY_FROMEDIT);
            if (fromEdit) {
                if (this._editInfo.tempId === fromEdit) {
                    // 一致する場合は、再遷移
                    return;
                }
                else {
                    // 上記以外の場合は、判定値更新
                    sessionStorage.setItem(this.SESSION_STORAGE_KEY_FROMEDIT, this._editInfo.tempId);
                }
            }
            else {
                sessionStorage.setItem(this.SESSION_STORAGE_KEY_FROMEDIT, this._editInfo.tempId);
            }
        }

        // ガイダンス表示
        var guidance = $("#previewGuidanceArea")
        if (guidance.css("display") === "none") {
            var elem = $("#previewController");
            elem.removeClass().addClass("anmon");
            guidance.css("display", "block");
        }

        // 時間経過でガイダンスを閉じる
        setTimeout(() => {
            this.btnClickGuidanceClose(null);
        }, this.GUIDANCE_SHOW_TIMEOUT);
    }

    /**
     * リファラ判定をします。
     * ハガキ選択画面からであれば true
     * それ以外であれば false
     * */
    private checkFromReferrer(pageName: string): boolean {
        const referrer = document.referrer;
        if (referrer) {
            const splitAdr = referrer.split('/');
            const splitParam = splitAdr[splitAdr.length - 1].split('?');
            if (splitParam[0].toLowerCase() == pageName) {
                return true;
            }
        }
        return false;
    }

    /**
     * F5リロードイベントとして[beforeunload]イベントを監視
     * */
    private unloadHandlerInit(): void {

        let that: previewController = this;
        let func = function () {
            that.unloadHandlerFunc(that);
        };
        window.removeEventListener('beforeunload', func);
        window.addEventListener('beforeunload', func);
    }

    /**
     * [beforeunload]イベント処理本体
     * @param contoroller ：editController
     */
    private unloadHandlerFunc(contoroller: previewController): void {
        if (contoroller.doUnloadEventFunc) {
            const dtNow: Date = new Date();
            sessionStorage.setItem(this.SESSION_STORAGE_KEY_RELOADED, dtNow.toUTCString());
        }
    }

    /**
     * F5リロード判定
     */
    private doReloaded(): boolean {

        // 取得
        const beforeunloadVal: string = sessionStorage.getItem(this.SESSION_STORAGE_KEY_RELOADED);
        Logger.debug("beforeunload [" + beforeunloadVal + "]");
        // クリア
        sessionStorage.setItem(this.SESSION_STORAGE_KEY_RELOADED, "");

        return beforeunloadVal ? true : false;
    }

    /**
     * プレビュー画面にいたことを保持しておく。
     * */
    private setFromPrev(): void {
        // タブ単位
        sessionStorage.setItem(this.SESSION_STORAGE_FROM_PREV,"true");
	}


    //--------------------------------------------------------------------------
    // イベント
    //--------------------------------------------------------------------------
    /**
    * 前画面遷移ボタン押下メソッド
    * */
    public btnClickReturnFlow(event: JQueryEventObject): void {

        // 画面遷時は、sessionStorageに書き込まない
        this.doUnloadEventFunc = false;

        if (this.getIsReturn()) {

            // 追加注文時は追加注文画面に戻る。
            window.location.href = this.ViewURL_AddOrder;
        } else {

            // 編集画面に戻る。
            let getParam = common.getGetParam();
            window.location.href = this.ViewURL_Edit + getParam;
            //history.back();
		}
        
    }

    /**
     * 次画面遷移ボタン押下メソッド
     * */
    public btnClickNextFlow(event: JQueryEventObject): void {

        // 画面遷時は、sessionStorageに書き込まない
        this.doUnloadEventFunc = false;

        // 1枚おためしはカートに遷移する。
        if (this._orderInfo.isTrial) {

            // カート遷移→強制保存
            common.SaveDataForceForCart(this._token,true);

        } else {

            // 通常注文はハガキ選択画面に遷移
            var form = document.createElement('form');
            form.action = this.ViewURL_HagakiSelect;
            form.method = 'POST';
            $('body').append(form);

            form.submit();
		}
    }

    /**
     * 一時保存ボタン押下メソッド
     * */
    public btnClickSave(event: JQueryEventObject): void {

        const editInfo: editInfo = util.lstorage.get<editInfo>(util.lstorage.KEY_EDIT, false);
        const orderInfo: orderInfo = util.lstorage.get<orderInfo>(util.lstorage.KEY_ORDER, false);
        common.SaveData(this._token, editInfo, orderInfo);

    }

    /**
     * 操作方法ボタン押下メソッド
     * */
    public btnClickOperationHelp(event: JQueryEventObject): void {

        ui.windowOpen(this._retailerConfig.operationInfo.preview, "", null, null);

    }

    /**
     * ガイダンス閉じる
     * @param event
     */
    public btnClickGuidanceClose(event: JQueryEventObject): void {
        var guidance = $("#previewGuidanceArea")
        if (guidance.css("display") !== "none") {
            var elem = $("#previewController");
            elem.removeClass().addClass("anmoff");
            $("#previewGuidanceArea").css("display", "none");
        }
    }

    /**
     * 説明文のバルーンボタン押下メソッド
     * @param event
     */
    public btnClickImgGuidance(event: JQueryEventObject): void {
        this._vue.$data.Show.ImgGuidance = false;
    }

    /**
     * ページエリア、ハガキサイズに連動して赤枠ガイダンス表示位置を調整(SP)
     * @param pdfHeight ：PDFエリアの高さ
     * @param pdfWidth  ：PDFエリアの幅
     */
    private setSpImgBorderGuidanceBalloonPos(pdfHeight, pdfWidth) {
        // 表示エリア
        const editAreaHeight: number = $(window).height() - $('#header').height() - $('#footer').height() - $('#commonMenuArea').height();
        const editAreaWidth: number = $(window).width();

        // 吹き出しの高さ
        const popUpHeight = 30;

        // 表示幅から表示している高さを計算
        const ratio = editAreaWidth / pdfWidth;
        const hagakiHeight = pdfHeight * ratio;

        // 同じSPでも画面の大きさによって表示範囲が異なるため、その対応
        const space = hagakiHeight > editAreaHeight ? (editAreaWidth - pdfWidth) / 2 : (editAreaHeight - hagakiHeight) / 2;
        const topPos = hagakiHeight > editAreaHeight ? editAreaHeight - popUpHeight - 10 : hagakiHeight + space - popUpHeight;

        this._vue.$data.ReplaceImgGuideBaloon.top = topPos + "px";
        this._vue.$data.ReplaceImgGuideBaloon.left = "10px";
    }

    /**
     * ページエリア、ハガキサイズに連動して赤枠ガイダンス表示位置を調整(PC)
     * @param editAreaWidth ：編集エリアの幅
     * @param pageSize      ：ハガキのサイズ(長辺)
     * @param minPageSize   ：ハガキのサイズ(短辺)
     * @param partrait      ：ハガキが縦長かどうか
     */
    private setImgBorderGuidanceBalloonPos(editAreaWidth: number, pageSize: number, minPageSize: number, isPortrait: boolean) {
        // ハガキの幅と高さ
        const hagakiWidth = isPortrait ? minPageSize : pageSize;
        const hagakiHeight = isPortrait ? pageSize : minPageSize;

        // ハガキの余白:　編集エリアの横幅 - ハガキの幅
        const spaceWidth: number = editAreaWidth - hagakiWidth;

        // X座標：余白 + 赤枠分
        const redWidthRate = isPortrait ? 0.05 : 0.03;
        this._vue.$data.ReplaceImgGuideBaloon.left = (Math.ceil(spaceWidth / 2) + Math.ceil(hagakiWidth * redWidthRate)) + "px";

        // ハガキの上下の余白
        const editHeight = $('#contents').height();
        const spaceHeight: number = Math.ceil((editHeight - hagakiHeight) / 2);

        // 吹き出しの高さ
        // 表示していない場合は要素の高さを取得できないため、取得できない場合は固定値とする
        const elm = this._vue.$refs.imageGuidance as HTMLInputElement
        const guideHeight: number = this._vue.$data.Show.ImgGuidance ? elm.getBoundingClientRect().height + 40 : 95;

        // Y座標：ハガキのページエリアの高さ + 上下の余白 - 赤枠と吹き出し位置を考慮した値
        this._vue.$data.ReplaceImgGuideBaloon.top = (hagakiHeight + spaceHeight - guideHeight) + "px";
    }
    
    
}
